import { Component } from '@angular/core';

@Component({
  selector: 'app-horizontal-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class HorizontalNavigationComponent {}
